import React from 'react';

import { createBEMClasses } from '@/utils/classname';

import { PARAGRAPH_COLORS, PARAGRAPH_SIZES, PARAGRAPH_WEIGHTS } from '../Paragraph/Paragraph';

import '../Paragraph/Paragraph.css';

const { block } = createBEMClasses('paragraph');

type InlineTextSize = (typeof PARAGRAPH_SIZES)[number];
type InlineTextWeight = (typeof PARAGRAPH_WEIGHTS)[number];
type InlineTextColor = (typeof PARAGRAPH_COLORS)[number];

type InlineTextBaseProps = React.AriaAttributes & React.HTMLAttributes<HTMLSpanElement>;

export interface InlineTextProps extends InlineTextBaseProps {
  size?: InlineTextSize;
  mobileSize?: InlineTextSize;
  weight?: InlineTextWeight;
  color?: InlineTextColor;
  children: React.ReactNode;
  nowrap?: boolean;
  ellipsis?: boolean;
  align?: 'left' | 'center' | 'right' | 'start' | 'end';
  textTransform?: 'capitalize' | 'uppercase' | 'lowercase' | 'none';
  whiteSpace?: 'normal' | 'nowrap' | 'pre-wrap' | 'pre-line';
  flex?: React.CSSProperties['flex'];
  title?: string;
  id?: string;
  ref?: React.Ref<HTMLSpanElement>;
}

const InlineText = ({
  size = '100',
  mobileSize,
  weight = 'regular',
  color,
  children,
  className,
  nowrap = false,
  ellipsis = false,
  align,
  textTransform,
  whiteSpace,
  flex,
  style,
  title,
  id,
  ref,
  ...rest
}: InlineTextProps) => {
  const commonProps = {
    ...rest,
    className: block(
      { size, weight, ...(color && { color }), ...(mobileSize && { 'mobile-size': mobileSize }) },
      className
    ),
    style: {
      ...style,
      whiteSpace: whiteSpace ?? (nowrap ? 'nowrap' : undefined),
      textOverflow: ellipsis ? 'ellipsis' : undefined,
      overflow: ellipsis ? 'hidden' : undefined,
      maxWidth: ellipsis ? '100%' : undefined,
      textAlign: align,
      textTransform,
      flex,
    },
    id,
    title,
  };

  return (
    <span ref={ref} {...commonProps}>
      {children}
    </span>
  );
};

export default InlineText;
